
// import { motion } from "framer-motion";
// import { useEffect, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import loginImg from "../assets/images/amass-pros-login-img.webp";
// import "./LoginOtp.css";
// import "./AuthResponsive.css";

// export default function LoginOtp() {
//   const navigate = useNavigate();
//   const { t } = useTranslation();
//   const [otp, setOtp] = useState(["", "", "", ""]);
//   const inputRefs = useRef([]);

//   const isOtpComplete = (values) => values.join("").length === 4;

//   const handleChange = (index, value) => {
//     const digit = value.replace(/\D/g, "").slice(-1);
//     const next = [...otp];
//     next[index] = digit;
//     setOtp(next);

//     if (digit && index < 3) {
//       inputRefs.current[index + 1]?.focus();
//     }
//     if (isOtpComplete(next)) {
//       navigate("/", { replace: true });
//     }
//   };

//   const handleKeyDown = (index, e) => {
//     if (e.key === "Backspace" && !otp[index] && index > 0) {
//       inputRefs.current[index - 1]?.focus();
//     }
//   };

//   const handlePaste = (e) => {
//     e.preventDefault();
//     const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 4);
//     if (!pasted) return;

//     const next = ["", "", "", ""];
//     for (let i = 0; i < pasted.length; i += 1) {
//       next[i] = pasted[i];
//     }
//     setOtp(next);

//     if (pasted.length < 4) {
//       inputRefs.current[pasted.length]?.focus();
//       return;
//     }
//     navigate("/", { replace: true });
//   };

//   useEffect(() => {
//     const onPopState = () => {
//       navigate("/login", { replace: true });
//     };
//     window.addEventListener("popstate", onPopState);
//     return () => window.removeEventListener("popstate", onPopState);
//   }, [navigate]);
//   const goLogin = () => {
//     navigate("/login", { replace: true });
//   };

//   return (
//     <div className="auth-page otp-page">
//       <div className="auth-container otp-auth-container">
//         <div className="auth-left">
//           <motion.div
//             className="otp-heading"
//             initial={{ opacity: 0, y: -20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6 }}
//           >
//             <h1>{t("otpVerifyTitle")}</h1>
//             <p>{t("otpVerifySubtitle")}</p>
//           </motion.div>

//           <div className="otp-wrapper">
//             {otp.map((digit, index) => (
//               <input
//                 key={index}
//                 ref={(el) => { inputRefs.current[index] = el; }}
//                 className="otp-input"
//                 maxLength="1"
//                 value={digit}
//                 onChange={(e) => handleChange(index, e.target.value)}
//                 onKeyDown={(e) => handleKeyDown(index, e)}
//                 onPaste={handlePaste}
//                 onFocus={(e) => e.target.select()}
//                 inputMode="numeric"
//                 autoFocus={index === 0}
//               />
//             ))}
//           </div>

//           <motion.button
//             whileHover={{ scale: 1.02 }}
//             whileTap={{ scale: 0.98 }}
//             onClick={() => window.open("https://amasspros.in/", "_blank", "noopener,noreferrer")}
//             className="btn"
//           >
//             {t("otpSubmit")}
//           </motion.button>

//           <p className="resend-text">
//             {t("otpResendQuestion")}{" "}
//             <span className="resend-link" onClick={goLogin}>
//               {t("otpResendAction")}
//             </span>
//           </p>

//           <button type="button" onClick={goLogin} className="otp-back-btn">
//             {t("otpBack")}
//           </button>
//         </div>

//         <div className="auth-right otp-auth-right">
//           <img src={loginImg} alt={t("otpImageAlt")} className="login-image otp-login-image" />
//         </div>
//       </div>
//     </div>
//   );
// }
import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import loginImg from "../assets/images/amass-pros-login-img.webp";
import "./LoginOtp.css";
import "./AuthResponsive.css";

export default function LoginOtp() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [otp, setOtp] = useState(["", "", "", ""]);
  const inputRefs = useRef([]);

  const isOtpComplete = (values) => values.join("").length === 4;

  const handleChange = (index, value) => {
    const digit = value.replace(/\D/g, "").slice(-1);
    const next = [...otp];
    next[index] = digit;
    setOtp(next);

    if (digit && index < 3) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      if (otp[index]) {
        const next = [...otp];
        next[index] = "";
        setOtp(next);
        return;
      }

      if (index > 0) {
        inputRefs.current[index - 1]?.focus();
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, 4);

    if (!pasted) return;

    const next = ["", "", "", ""];
    for (let i = 0; i < pasted.length; i += 1) {
      next[i] = pasted[i];
    }

    setOtp(next);

    if (pasted.length < 4) {
      inputRefs.current[pasted.length]?.focus();
    } else {
      inputRefs.current[3]?.focus();
    }
  };

  const handleSubmit = () => {
    if (!isOtpComplete(otp)) return;
    navigate("/", { replace: true });
  };

  useEffect(() => {
    const onPopState = () => {
      navigate("/login", { replace: true });
    };

    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, [navigate]);

  const goLogin = () => {
    navigate("/login", { replace: true });
  };

  return (
    <div className="auth-page otp-page">
      <div className="auth-container otp-auth-container">
        <div className="auth-left">
          <motion.div
            className="otp-heading"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1>{t("otpVerifyTitle") || "Verify Your Phone"}</h1>
            <p>{t("otpVerifySubtitle") || "Enter the OTP sent to your phone number"}</p>
          </motion.div>

          <div className="otp-wrapper">
            {otp.map((digit, index) => (
              <input
                key={index}
                ref={(el) => {
                  inputRefs.current[index] = el;
                }}
                className="otp-input"
                maxLength="1"
                value={digit}
                onChange={(e) => handleChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                onPaste={handlePaste}
                onFocus={(e) => e.target.select()}
                inputMode="numeric"
                autoFocus={index === 0}
              />
            ))}
          </div>

          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={handleSubmit}
            className="btn"
            type="button"
            disabled={!isOtpComplete(otp)}
          >
            {t("otpSubmit") || "Submit"}
          </motion.button>

          <p className="resend-text">
            {t("otpResendQuestion") || "Didn’t receive code?"}{" "}
            <span className="resend-link" onClick={goLogin}>
              {t("otpResendAction") || "Resend"}
            </span>
          </p>

          <button type="button" onClick={goLogin} className="otp-back-btn">
            {t("otpBack") || "Back"}
          </button>
        </div>

        <div className="auth-right otp-auth-right">
          <img
            src={loginImg}
            alt={t("otpImageAlt") || "OTP"}
            className="login-image otp-login-image"
          />
        </div>
      </div>
    </div>
  );
}
